import styled, { keyframes } from "styled-components";

export const TrustedSection = styled.div`
  margin: 0 auto;
  align-items: center;
  text-align: center;
  max-width: 966px;
  background:black;
  overflow: hidden;
  

  > h1 {
    text-align: center;
    text-transform: uppercase;
    backdrop-filter: blur(6px);
    width: 100%;
    display:none;

    padding: 16px 0 36px;
    font-size: 16px;
    margin: 0;
  }
  .marque_container {
    lign-items: center;
    display: flex;
    flex: none;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 88px;
    height: min-content;
    justify-content: center;
    overflow: visible;
    padding: 48px;
    position: relative;
    width: 100%;
    border-left: 1px solid #1f1f1f;
    border-right: 1px solid #1f1f1f;
    border-bottom: 1px solid #1f1f1f;
  }
  .alt_text {
  
    > div {
      flex-shrink: 0;
      >p{
      font-size:18px;
      font-weight:500;
      color: #969696ff;
      }
    }
  }
  @media (max-width: 550px) {
    
    .alt_text {
      display: none;
    }
      .marque_container{
            padding:0px;

      }
      h1{
      display:inline-block}
  }
`;

interface TrustedSectionImgProp {
  imgWidth?: string;
  imgHeight?: string;
  mobileHeight?: string;
}
export const TrustedSectionImg = styled.img<TrustedSectionImgProp>`
  width: ${(p) => p.imgWidth || "30rem"};
  height: ${(p) => p.imgHeight || "60px"};

  @media (max-width: 550px) {
    width: 150px;
    height: ${(p) => p.mobileHeight || "60px"};
  }
`;
export const MarqueeContainer = styled.div`
  --marquee-width: 100vw;
  --marquee-elements-displayed: 7;
  --marquee-element-width: calc(
    var(--marquee-width) / var(--marquee-elements-displayed)
  );
  --marquee-animation-duration: calc(var(--marquee-elements) * 3s);
  min-height: var(--marquee-height);
  color: black;
  overflow: hidden;
  position: relative;
  mask-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 0%,
    rgb(0, 0, 0) 12.5%,
    rgb(0, 0, 0) 87.5%,
    rgba(0, 0, 0, 1) 100%
  );
  overflow: hidden;
  &:before,
  &:after {
    content: "";
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0) 0%,
      rgb(0, 0, 0) 12.5%,
      rgb(0, 0, 0) 87.5%,
      rgba(0, 0, 0, 1) 100%
    );
    position: absolute;
    width: 100px;
    height: 100%;
    top: 0;
    z-index: 2;
  }
  &:before {
    left: 0;
  }
  &:after {
    right: 0;
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0) 12.5%,
      rgba(0, 0, 0, 1) 87.5%,
      rgba(0, 0, 0, 1) 100%
    );
  }

  @media (max-width: 550px) {
    margin-top: 0rem;
    margin-bottom: 0rem;
  }
`;

const scrolling = keyframes`
  to { left: -200px }
`;

export const MarqueeContent = styled.div`
  margin-inline: auto;
  position: relative;
  height: 100px;
  width: 100vw;

  overflow: hidden;

  background: transparent;
  z-index: 2;

  :hover {
    > div {
      animation-play-state: paused;
    }
  }
  @media (max-width: 550px) {
  }
`;


export const MarqueeItem = styled.div`
  --units: 1;
  width: 200px;
  height: 70px;
  background-color: transparent;

  display: flex;
  align-items: center;
  top: 15px;
  border-radius: 6px;
  position: absolute;
  left: max(calc(200px * 8), 100%);
  animation-name: ${scrolling};
  animation-duration: 30s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-delay: calc(30s / 8 * (8 - var(--units)) * -1);
  &:nth-child(2) {
    --units: 2;
  }
  &:nth-child(3) {
    --units: 3;
  }
  &:nth-child(4) {
    --units: 4;
  }
  &:nth-child(5) {
    --units: 5;
  }

  &:nth-child(6) {
    --units: 6;
  }

  &:nth-child(7) {
    --units: 7;
  }

  &:nth-child(8) {
    --units: 8;
  }
  > svg {
    width: 40px;
    height: 40px;
  }
`;
